"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var genId = function (i) {
  return function () {
    return ++i;
  };
}(0);

var _default = genId;
exports.default = _default;